<soft-overlay [mode]="'sidebar'"
              [open]="service.opened()"
              [header]="sidebarHeader"
              [content]="sidebarContent"
              [footer]="sidebarFooter"
              (openChange)="$event ? service.opened.set(true) : service.opened.set(false)">
</soft-overlay>

<ng-template #sidebarHeader>
  <div class="sidebar-header">
    <div class="sidebar-header-title-row">
      <h2 class="ds-title-1-semibold">
        @if (canBack()) {
          <div class="flex flex-row gap-2 hover:cursor-pointer" (click)="back()">
            <soft-icon [name]="'fa-regular fa-arrow-left'" size="sm" />
            <span>{{ title() }}</span>
          </div>
        }
        @else {
          {{ title() }}
        }
      </h2>
      <soft-ds-button mode="iconOnly" variant="ghost" size="sm"
                      [aria-label]="'#CORE_FILTER.CLOSE' | translate"
                      (click)="cancel()"
                      data-testid="page-filter-close">
        <soft-ds-icon name="fa-regular fa-xmark" />
      </soft-ds-button>
    </div>

    @if (templateService && service.view() === 'filter' && tabsVisible()) {
      <soft-page-filter-templates-dropdown [templateService]="templateService"
                                           target="draft"
                                           fullWidth
                                           (manage)="openTemplateManagement()"
                                           data-testid="page-filter-templates-dropdown" />
    }
  </div>
</ng-template>

<ng-template #sidebarContent>

  <div class="sidebar-filter-scroll">
    @if(service.view() === 'filter' && tabsVisible()) {
      <div class="sidebar-body-tabs">
        <soft-ds-tabs [tabs]="viewTabs()"
                      [variant]="'segmented'"
                      [size]="'sm'"
                      [layout]="'fill'"
                      [value]="service.tab()"
                      (valueChange)="$event && service.tab.set($event)">
        </soft-ds-tabs>
      </div>
    }

    @if (service.view() === 'templates') {
      <soft-page-filter-templates></soft-page-filter-templates>
    }
    @else if (service.tab() === 'list') {
      <soft-page-filter-list></soft-page-filter-list>
    } @else if (service.tab() === 'custom') {
      <soft-page-filter-custom></soft-page-filter-custom>
    }
  </div>
</ng-template>

<ng-template #sidebarFooter>
  <div class="sidebar-footer-actions">
    <soft-ds-button variant="ghost" size="lg" (click)="reset()">
      {{ '#CORE_FILTER.RESET' | translate }}
    </soft-ds-button>
    <soft-ds-button class="ml-auto" variant="secondary" size="lg" (click)="cancel()">
      {{ '#CORE_FILTER.CANCEL' | translate }}
    </soft-ds-button>
    <soft-ds-button variant="primary" size="lg" [disabled]="!canApply()" (click)="apply()">
      {{ '#CORE_FILTER.APPLY' | translate }}
    </soft-ds-button>
  </div>
</ng-template>
